import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { isCampaignStateError } from "./campaignStateErrors";

export function useUpdateAdState() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: Parameters<typeof apiClient.setAdState>[0]) => {
      await apiClient.setAdState(vars);
    },
    meta: {
      // The caller named an advertisement outside its account, not a defect.
      expectedError: (error: unknown) => isCampaignStateError(error, "advertisement_not_found"),
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [{ entity: "V4AdvReportByAd" }],
      });
    },
  });
}
